<template>
    <div>
        <el-dialog
                title="Изменение типа оплаты"
                :visible.sync="$store.getters.showOrderPaymentTypeDialog"
                width="60%"
                :before-close="handleClose"
        >
            <el-form id="uploadForm" name="uploadForm" label-position="right" enctype="multipart/form-data">
                <el-form-item label="Тип оплаты">
                    <el-select v-model="paymentType">
                        <el-option
                            v-for="(item, index) in paymentTypeOrderConfig"
                            :key="index"
                            :value="item.value"
                            :label="item.title"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Оплачен" v-if="paymentType === paymentTypeConfig.bill.value">
                    <el-checkbox v-model="paid"></el-checkbox>
                </el-form-item>

            </el-form>
            <el-button @click="handleClose">Отмена</el-button>
            <el-button @click="savePaymentTypeOrder">Сохранить</el-button>


        </el-dialog>


    </div>

</template>

<script>

import axios from "axios";
import paymentTypeOrderConfig from '../../../composable/config/order-type-payment-config';
import paymentTypeConfig from '../../../composable/type/payment-type-order.type'


export default {
    props: ['orderId', 'paymentType1'],
    data: function (){
        return{
            paymentType:'',
            paid: false,
            paymentTypeConfig,
            paymentTypeOrderConfig
        }
    },
    mounted() {
        this.$store.subscribe((mutation) => {
          if (mutation.type === 'showOrderPaymentTypeDialog' && mutation.payload) {
              this.paymentType = this?.paymentType1 || ''
          }
        })
    },
    methods: {

        savePaymentTypeOrder() {
            let data = {
                payment_type: this.paymentType
            }

            if (this.paymentType === this.paymentTypeConfig.bill.value) {
                data['paid'] = this.paid
            }

            axios.post('/order/' + this.orderId + '/payment', data).then(() => {
                    this.handleClose()
                    this.$emit('updateParent');
                }
            ).catch((errors) => {
                if (errors.response.status === 401) {
                    this.$router.push('/login');
                } else if (errors.response.status === 500) {
                    this.$notify.error({
                        title: 'Не удалось сменить тип оплаты',
                        message: 'Не известная ошибка'
                    })
                }
                else if(errors?.response?.data?.message) {
                    this.$notify.error({
                        title: 'Не удалось сменить тип оплаты',
                        message: errors.response.data.message ?? ''
                    })
                }
            });
        },
        handleClose() {
            this.$store.commit('showOrderPaymentTypeDialog', false);
        },
    }
}
</script>

<style scoped>

</style>